// extracted by mini-css-extract-plugin
var _1 = "webpack-concepts-Extraction-Blocks-TextField-control-SuggestibleTextField-module__suggestedField";
export { _1 as "suggestedField" }
